/* =====================================
   LALO BY LEY — THEME.JS
   Core: Preloader, Cursor, Smooth Scroll,
   GSAP Animations, Navigation
   ===================================== */

document.addEventListener('DOMContentLoaded', () => {
  // Remove no-js class
  document.documentElement.classList.remove('no-js');

  /* ----------------------------------------
     SMOOTH SCROLL — LENIS
  ---------------------------------------- */
  const lenis = new Lenis({
    duration: 1.4,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical',
    smooth: true,
    smoothTouch: false,
    touchMultiplier: 2,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // Bridge Lenis with GSAP ScrollTrigger
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);

  /* ----------------------------------------
     PRELOADER ELIMINADO — hero se activa directamente
  ---------------------------------------- */
  const preloader = null; // Eliminado para mayor velocidad

  /* ----------------------------------------
     CUSTOM CURSOR
  ---------------------------------------- */
  const cursor = document.getElementById('cursor');
  const cursorDot = cursor?.querySelector('.cursor__dot');
  const cursorCircle = cursor?.querySelector('.cursor__circle');
  const cursorText = cursor?.querySelector('.cursor__text');

  if (cursor && window.matchMedia('(pointer: fine)').matches) {
    let mouseX = -100, mouseY = -100;
    let circleX = -100, circleY = -100;

    const updateCursor = () => {
      // Dot follows exactly
      gsap.set(cursorDot, { x: mouseX, y: mouseY });
      // Circle lerps
      circleX += (mouseX - circleX) * 0.12;
      circleY += (mouseY - circleY) * 0.12;
      gsap.set(cursorCircle, { x: circleX, y: circleY });
      gsap.set(cursorText, { x: circleX, y: circleY });
      requestAnimationFrame(updateCursor);
    };
    requestAnimationFrame(updateCursor);

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.classList.remove('cursor--hidden');
    });

    document.addEventListener('mouseleave', () => {
      cursor.classList.add('cursor--hidden');
    });

    // Cursor state on interactive elements
    const hoverTargets = document.querySelectorAll('a, button, [data-cursor]');
    hoverTargets.forEach(el => {
      el.addEventListener('mouseenter', () => {
        cursor.classList.add('cursor--expanded');
        if (el.dataset.cursor) {
          cursor.classList.add('cursor--image');
          cursorText.textContent = el.dataset.cursor;
        }
      });
      el.addEventListener('mouseleave', () => {
        cursor.classList.remove('cursor--expanded', 'cursor--image');
        cursorText.textContent = '';
      });
    });

    // Large images
    document.querySelectorAll('img, video, .collection-card, .editorial__image-wrap').forEach(el => {
      el.addEventListener('mouseenter', () => {
        cursor.classList.add('cursor--image');
        cursorText.textContent = 'Ver';
      });
      el.addEventListener('mouseleave', () => {
        cursor.classList.remove('cursor--image');
        cursorText.textContent = '';
      });
    });
  }

  /* ----------------------------------------
     NAVIGATION
  ---------------------------------------- */
  const header = document.querySelector('.site-header');
  const hamburger = document.querySelector('.site-header__hamburger');
  const mobileNav = document.querySelector('.mobile-nav');

  // Scroll state
  let lastScrollY = 0;
  lenis.on('scroll', ({ scroll }) => {
    if (scroll > 80) {
      header?.classList.add('scrolled');
    } else {
      header?.classList.remove('scrolled');
    }
    lastScrollY = scroll;
  });

  // Mobile menu toggle
  hamburger?.addEventListener('click', () => {
    const isOpen = mobileNav?.classList.toggle('open');
    hamburger.setAttribute('aria-expanded', isOpen);

    const spans = hamburger.querySelectorAll('span');
    if (isOpen) {
      gsap.to(spans[0], { rotation: 45, y: 6, duration: 0.4, ease: 'power2.inOut' });
      gsap.to(spans[1], { opacity: 0, duration: 0.2 });
      gsap.to(spans[2], { rotation: -45, y: -6, duration: 0.4, ease: 'power2.inOut' });
      lenis.stop();
    } else {
      gsap.to(spans[0], { rotation: 0, y: 0, duration: 0.4, ease: 'power2.inOut' });
      gsap.to(spans[1], { opacity: 1, duration: 0.2 });
      gsap.to(spans[2], { rotation: 0, y: 0, duration: 0.4, ease: 'power2.inOut' });
      lenis.start();
    }
  });

  // Close on nav link click (only actual links, not toggles)
  document.querySelectorAll('.mobile-nav__link:not(.mobile-nav__link--toggle), .mobile-nav__sublink:not(.mobile-nav__sublink--toggle), .mobile-nav__sub-sublink').forEach(link => {
    link.addEventListener('click', () => {
      mobileNav?.classList.remove('open');
      lenis.start();
      // Reset hamburger
      const spans = hamburger?.querySelectorAll('span');
      if (spans) {
        gsap.to(spans[0], { rotation: 0, y: 0, duration: 0.4, ease: 'power2.inOut' });
        gsap.to(spans[1], { opacity: 1, duration: 0.2 });
        gsap.to(spans[2], { rotation: 0, y: 0, duration: 0.4, ease: 'power2.inOut' });
      }
    });
  });

  // Mobile menu accordion — Generic toggle system (works with Shopify linklists)
  document.querySelectorAll('[data-toggle-target]').forEach(toggle => {
    const targetId = toggle.getAttribute('data-toggle-target');
    const target = document.getElementById(targetId);
    if (!target) return;
    
    toggle.addEventListener('click', () => {
      toggle.classList.toggle('active');
      target.classList.toggle('open');
    });
  });

  /* ----------------------------------------
     SCROLL PROGRESS BAR
  ---------------------------------------- */
  const progressBar = document.querySelector('.scroll-progress');
  if (progressBar) {
    lenis.on('scroll', ({ progress }) => {
      gsap.set(progressBar, { scaleX: progress });
    });
  }

  /* ----------------------------------------
     REVEAL ANIMATIONS — ScrollTrigger
  ---------------------------------------- */
  // Wait for GSAP to be ready
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  // Generic fade-up
  gsap.utils.toArray('[data-animate="fade-up"]').forEach(el => {
    gsap.fromTo(el,
      { opacity: 0, y: 50 },
      {
        opacity: 1, y: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
        delay: parseFloat(el.dataset.delay || 0),
      }
    );
  });

  // Fade in
  gsap.utils.toArray('[data-animate="fade-in"]').forEach(el => {
    gsap.fromTo(el,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 1.2,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
        },
        delay: parseFloat(el.dataset.delay || 0),
      }
    );
  });

  // Scale up
  gsap.utils.toArray('[data-animate="scale-up"]').forEach(el => {
    gsap.fromTo(el,
      { opacity: 0, scale: 0.9 },
      {
        opacity: 1, scale: 1,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
        },
      }
    );
  });

  // Stagger children
  gsap.utils.toArray('[data-stagger]').forEach(container => {
    const children = container.children;
    gsap.fromTo(children,
      { opacity: 0, y: 30 },
      {
        opacity: 1, y: 0,
        duration: 0.8,
        stagger: 0.12,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: container,
          start: 'top 80%',
        },
      }
    );
  });

  /* ----------------------------------------
     IMAGE CURTAIN REVEALS
  ---------------------------------------- */
  gsap.utils.toArray('.reveal-image').forEach(el => {
    const img = el.querySelector('img, video');
    if (!img) return;

    const curtain = document.createElement('div');
    curtain.style.cssText = `
      position: absolute; inset: 0; z-index: 2;
      background: var(--color-bg);
      transform-origin: bottom;
    `;
    el.style.position = 'relative';
    el.style.overflow = 'hidden';
    el.appendChild(curtain);

    gsap.fromTo(curtain,
      { clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)' },
      {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
        duration: 1.4,
        ease: 'power4.inOut',
        scrollTrigger: {
          trigger: el,
          start: 'top 75%',
        },
      }
    );

    gsap.fromTo(img,
      { scale: 1.15 },
      {
        scale: 1,
        duration: 1.4,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 75%',
        },
      }
    );
  });

  /* ----------------------------------------
     PARALLAX LAYERS (Aggressive & Smooth)
  ---------------------------------------- */
  gsap.utils.toArray('[data-parallax], [data-speed]').forEach(el => {
    const speed = parseFloat(el.dataset.parallax || el.dataset.speed || 0.5);
    gsap.to(el, {
      yPercent: speed * 40, // Increased multiplier for aggressive offset
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1, // Slower scrub for feeling of weight
      },
    });
  });

  /* ----------------------------------------
     MANIFESTO BLUR-IN / STAGGER TEXT
  ---------------------------------------- */
  const manifestoBody = document.querySelector('.manifesto__body');
  if (manifestoBody) {
    const text = manifestoBody.textContent.trim();
    const words = text.split(' ');
    manifestoBody.innerHTML = words.map(w =>
      `<span class="split-word"><span>${w}</span></span>`
    ).join(' ');

    ScrollTrigger.create({
      trigger: manifestoBody,
      start: 'top 75%',
      onEnter: () => {
        const spans = manifestoBody.querySelectorAll('.split-word span');
        gsap.fromTo(spans,
          { y: '100%', opacity: 0 },
          {
            y: '0%',
            opacity: 1,
            duration: 0.7,
            stagger: 0.04,
            ease: 'power3.out',
          }
        );
      },
    });
  }

  /* ----------------------------------------
     B&W TO COLOR IMAGE REVEAL
  ---------------------------------------- */
  gsap.utils.toArray('.manifesto__visual').forEach(el => {
    const img = el.querySelector('img');
    const overlay = el.querySelector('.manifesto__visual-overlay');

    ScrollTrigger.create({
      trigger: el,
      start: 'top 60%',
      onEnter: () => {
        // Textures and filters pop
        if(img) {
          gsap.to(img, {
            filter: 'grayscale(0%) sepia(10%) hue-rotate(0deg) saturate(1.4) contrast(1.1)',
            duration: 2,
            ease: 'expo.out',
          });
        }
        if (overlay) {
          gsap.to(overlay, { opacity: 1, duration: 1.5 });
        }
        // Liquid clip-path expand
        if (el.classList.contains('liquid-reveal')) {
          gsap.to(el, {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            duration: 2.5,
            ease: 'power4.inOut'
          });
        }
      },
    });
  });

  /* ----------------------------------------
     MARQUEE STRIP — INFINITE LOOP FIX
  ---------------------------------------- */
  const marqueeStrips = document.querySelectorAll('.marquee-strip');
  
  marqueeStrips.forEach(strip => {
    const tracks = strip.querySelectorAll('.marquee-track');
    if (!tracks.length) return;

    // Animate all tracks in the same horizontal direction
    gsap.to(tracks, {
      xPercent: -100,
      duration: 25,
      ease: 'none',
      repeat: -1,
    });

    // Pause on hover
    strip.addEventListener('mouseenter', () => {
      gsap.to(tracks, { timeScale: 0.2, duration: 0.6 });
    });
    strip.addEventListener('mouseleave', () => {
      gsap.to(tracks, { timeScale: 1, duration: 0.6 });
    });
  });

  /* ----------------------------------------
     HERO TITLE REVEAL — inmediato (preloader eliminado)
  ---------------------------------------- */
  setTimeout(initHeroAnimations, 50);

  function initHeroAnimations() {
    const titleWords = document.querySelectorAll('.hero__title-word');
    const heroLabel = document.querySelector('.hero__label');
    const heroScroll = document.querySelector('.hero__scroll-hint');

    if (titleWords.length) {
      gsap.to(titleWords, {
        y: '0%',
        duration: 1.2,
        stagger: 0.08,
        ease: 'power4.out',
      });
    }

    if (heroLabel) {
      gsap.fromTo(heroLabel,
        { opacity: 0, y: 10 },
        { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', delay: 0.6 }
      );
    }

    if (heroScroll) {
      gsap.fromTo(heroScroll,
        { opacity: 0 },
        { opacity: 1, duration: 1, ease: 'power2.out', delay: 1.2 }
      );
    }

    // Disruptive Hero Scale & Mask Expand
    const heroMedia = document.querySelector('.hero__video, .hero__image');
    const heroMaskContainer = document.querySelector('.hero-clip-mask');

    if (heroMedia) {
      gsap.fromTo(heroMedia,
        { scale: 1.4, filter: 'contrast(1.5) blur(10px)' },
        { scale: 1, filter: 'contrast(1) blur(0px)', duration: 2.5, ease: 'expo.out', delay: 0.1 }
      );
    }

    if (heroMaskContainer) {
      gsap.fromTo(heroMaskContainer,
        { clipPath: 'circle(0% at 50% 50%)' },
        { clipPath: 'circle(150% at 50% 50%)', duration: 2.2, ease: 'power4.inOut', delay: 0.1 }
      );
    }
  }

  /* ----------------------------------------
     GALLERY THUMBNAILS (Product page)
  ---------------------------------------- */
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImg = document.querySelector('.product-showcase__image-wrap > img');

  if (thumbs.length && mainImg) {
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        const src = thumb.querySelector('img')?.src;
        if (src && mainImg) {
          gsap.to(mainImg, {
            opacity: 0,
            scale: 1.04,
            duration: 0.3,
            ease: 'power2.in',
            onComplete: () => {
              mainImg.src = src;
              gsap.to(mainImg, {
                opacity: 1,
                scale: 1,
                duration: 0.5,
                ease: 'power2.out',
              });
            },
          });
        }
      });
    });
  }

  /* ----------------------------------------
     SIZE SELECTOR
  ---------------------------------------- */
  const sizeBtns = document.querySelectorAll('.size-btn');
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* ----------------------------------------
     ACCORDION
  ---------------------------------------- */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const content = item.querySelector('.accordion-content');
      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.accordion-item.open').forEach(openItem => {
        openItem.classList.remove('open');
        openItem.querySelector('.accordion-content').classList.remove('open');
      });

      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('open');
        content.classList.add('open');
      }
    });
  });

  /* ----------------------------------------
     FORM — Floating Labels
  ---------------------------------------- */
  document.querySelectorAll('.form-group input, .form-group textarea').forEach(input => {
    // Check initial state
    if (input.value) {
      input.classList.add('has-value');
    }

    input.addEventListener('input', () => {
      input.classList.toggle('has-value', !!input.value);
    });
  });

  /* ----------------------------------------
     CONTACT FORM SUBMIT
  ---------------------------------------- */
  const contactForm = document.querySelector('.contact-form');
  contactForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    const btn = contactForm.querySelector('[type="submit"]');
    if (btn) {
      btn.textContent = 'Enviado ✓';
      btn.disabled = true;
      gsap.fromTo(btn, { scale: 0.95 }, { scale: 1, duration: 0.4, ease: 'back.out(2)' });
    }
  });

  /* ----------------------------------------
     PAGE TRANSITION
     Disabled in Shopify to prevent iframe routing issues in Customizer.
  ---------------------------------------- */
  // The page transition logic caused 404s in the Shopify editor because 
  // window.location.href dropping the editor's preview query parameters.


  /* ----------------------------------------
     MAGNETIC BUTTONS
  ---------------------------------------- */
  document.querySelectorAll('.magnetic').forEach(el => {
    const bounds = el.getBoundingClientRect();
    let isHovered = false;

    el.addEventListener('mouseenter', () => { isHovered = true; });
    el.addEventListener('mouseleave', () => {
      isHovered = false;
      gsap.to(el, { x: 0, y: 0, duration: 0.4, ease: 'elastic.out(1, 0.4)' });
    });

    document.addEventListener('mousemove', (e) => {
      if (!isHovered) return;
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = (e.clientX - cx) * 0.35;
      const dy = (e.clientY - cy) * 0.35;
      gsap.to(el, { x: dx, y: dy, duration: 0.3, ease: 'power2.out' });
    });
  });

  /* ----------------------------------------
     HERO — Parallax text on scroll
  ---------------------------------------- */
  const heroBgText = document.querySelector('.hero__bg-text');
  if (heroBgText) {
    gsap.to(heroBgText, {
      y: '40%',
      ease: 'none',
      scrollTrigger: {
        trigger: '.hero',
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
    });
  }

  /* ----------------------------------------
     COLLECTION STRIP — Drag scroll
  ---------------------------------------- */
  const stripScroll = document.querySelector('.collection-strip__scroll');
  if (stripScroll) {
    let isDown = false;
    let startX;
    let scrollLeft;

    stripScroll.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - stripScroll.offsetLeft;
      scrollLeft = stripScroll.scrollLeft;
      stripScroll.style.cursor = 'grabbing';
    });

    document.addEventListener('mouseup', () => {
      isDown = false;
      stripScroll.style.cursor = 'none';
    });

    stripScroll.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - stripScroll.offsetLeft;
      const walk = (x - startX) * 1.5;
      stripScroll.scrollLeft = scrollLeft - walk;
    });
  }


  /* ----------------------------------------
     SMOOTH ANCHOR NAV (data-smooth-anchor)
  ---------------------------------------- */
  document.querySelectorAll('[data-smooth-anchor]').forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      // Close mobile nav if open
      mobileNav?.classList.remove('open');
      lenis.start();
      // Scroll with header offset
      const headerH = document.getElementById('site-header')?.offsetHeight || 80;
      lenis.scrollTo(target, { offset: -headerH, duration: 1.4 });
    });
  });

  /* ----------------------------------------
     PRODUCT PAGE EDITORIAL LOGIC
     NOTE: Buy Now logic is handled exclusively inside each product
     section (main-product.liquid / product-details-swiss.liquid)
     via type="button" + native form submit. Do NOT add handlers here.
  ---------------------------------------- */

});
